import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = {
  id: "navigationPlaceholder",
  style: {"padding-top":"80px"}
}
const _hoisted_2 = { class: "container" }
const _hoisted_3 = ["href"]

import { computed, ref, reactive, watch, onMounted } from 'vue'
    import { guid } from '@common/Guid'
    import { useId, useOrganizationUnitId } from '@common/composables'
    import { useAdminManageConnectorsPage } from '@Integrations/Connectors/pages-core'
    import AdminNavigationV2 from '@common/AdminNavigationV2.vue'

    
export default /*@__PURE__*/_defineComponent({
  __name: 'AdminManageConnectorsPage',
  setup(__props) {

    document.title = "Manage connectors"

    const tid = useOrganizationUnitId()

    const { useCurrentUserQuery, useConnectorsOfOrganizationQuery, useCreateConnectorCommand } = useAdminManageConnectorsPage()

    const { modelCurrentUserQueryV1, runCurrentUserQueryV1 } = useCurrentUserQuery()
    const userId = computed(() => modelCurrentUserQueryV1.value?.UserId)

    const { modelConnectorsOfOrganizationQueryV1, runConnectorsOfOrganizationQueryV1 } = useConnectorsOfOrganizationQuery(tid)
    const connectors = computed(() => modelConnectorsOfOrganizationQueryV1.value?.Connectors || [])

    const { invokeCreateConnectorCommandV1, succeedCreateConnectorCommandV1 } = useCreateConnectorCommand(() => guid(), tid, userId, null)

    onMounted(() => {
        runCurrentUserQueryV1()
        runConnectorsOfOrganizationQueryV1()
    })

    watch(succeedCreateConnectorCommandV1, () => runConnectorsOfOrganizationQueryV1())

    function handleCreateConnectorCommandV1() {
        const name = prompt('Enter a new connector name')
        if (name) { invokeCreateConnectorCommandV1({ Name: name }) }
    }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(AdminNavigationV2, { tid: _unref(tid) }, null, 8 /* PROPS */, ["tid"])
    ]),
    _createElementVNode("div", { class: "container" }, [
      _createElementVNode("div", { class: "row" }, [
        _cache[0] || (_cache[0] = _createElementVNode("div", { class: "col-lg-7" }, [
          _createElementVNode("h1", { style: {"font-size":"2em","font-weight":"300","color":"#33475b"} }, "Manage connectors")
        ], -1 /* CACHED */)),
        _createElementVNode("div", { class: "col-lg-5 col-sm-6 text-right" }, [
          _createElementVNode("button", {
            onClick: handleCreateConnectorCommandV1,
            class: "btn btn-success"
          }, "Create connector")
        ])
      ])
    ]),
    _cache[1] || (_cache[1] = _createElementVNode("hr", { style: {"border-color":"#bbb","margin":"20px 0 30px"} }, null, -1 /* CACHED */)),
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(connectors.value, (d) => {
        return (_openBlock(), _createElementBlock("div", {
          key: d.ConnectorId
        }, [
          _createElementVNode("a", {
            href: `/#/admin/integrations/connectors/details/${d.ConnectorId}`
          }, _toDisplayString(d.Name), 9 /* TEXT, PROPS */, _hoisted_3)
        ]))
      }), 128 /* KEYED_FRAGMENT */))
    ])
  ]))
}
}

})